import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const MoreVertical = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='MoreVertical' {...props}>
    <path d='M14,14 L10,14 L10,10 L14,10 L14,14 Z M14,7 L10,7 L10,3 L14,3 L14,7 Z M14,21 L10,21 L10,17 L14,17 L14,21 Z' />
  </StyledIcon>
);
